import valueReducer from '../../../common/reducers/valueReducer';
import { SET_BREAKDOWN } from './constants';

const reducer = valueReducer([], SET_BREAKDOWN);

export default reducer;
